import StarIcon from '@mui/icons-material/Star';
import StarHalfIcon from '@mui/icons-material/StarHalf';
import StarOutlineIcon from '@mui/icons-material/StarOutline';
import { styled } from '@mui/material/styles';

interface WolfStarRateProps {
  rating: number;
}

const StarContainer = styled('div')({
  display: 'flex',
  flexDirection: 'row',
});

const WolfStarRate: React.FC<WolfStarRateProps> = ({ rating }) => {
  const renderStars = () => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      if (rating >= i) {
        stars.push(<StarIcon key={i} className="text-utilityLemon" />);
      } else if (rating >= i - 0.5) {
        stars.push(<StarHalfIcon key={i} className="text-utilityLemon" />);
      } else {
        stars.push(<StarOutlineIcon key={i} className="text-utilityLemon" />);
      }
    }
    return stars;
  };

  return <StarContainer>{renderStars()}</StarContainer>;
};

export default WolfStarRate;
